import { RootState } from "../../../../store";
import { resourceExplorerFilterByKeyAndProviderSelector } from "../resourceExplorerFilterByKeyAndProviderSelector";
import {
  ProviderType,
  ResourceExplorerFilterItem,
  ResourceExplorerFilterKeyType,
} from "../../../../../services/cloudchipr.api";
import { resourceExplorerPossibleFiltersByProviderSelector } from "../possible-filters/resourceExplorerPossibleFiltersByProviderSelector";
import { resourceExplorerProvidersSelector } from "../../current-resource-explorer/resourceExplorerProvidersSelector";
import { enabledProvidersSelector } from "../../../../common/selectors/billing-analytics/enabled-providers/enabledProvidersSelector";
import { getResourceExplorerRestructuredFilters } from "../../../utils/helpers/getResourceExplorerRestructuredFilters";
import { resourceExplorerViewDataByIdSelector } from "../../resource-explorer-by-id/resourceExplorerViewDataByIdSelector";

interface AppliedFiltersDependOnInitialOperatorSelectorArg {
  viewId: string;
  key: ResourceExplorerFilterKeyType;
  provider: ProviderType;
}
export const appliedFiltersDependOnInitialOperatorSelector = (
  state: RootState,
  { viewId, key, provider }: AppliedFiltersDependOnInitialOperatorSelectorArg,
): ResourceExplorerFilterItem | undefined => {
  const filter = resourceExplorerFilterByKeyAndProviderSelector(
    state,
    key,
    provider,
  );

  if (!filter) {
    return;
  }

  const resourceExplorerViewFilters = resourceExplorerViewDataByIdSelector(
    state,
    viewId,
  )?.filters;

  const possibleFilters = resourceExplorerPossibleFiltersByProviderSelector(
    state,
    provider,
  )?.[key];
  const resourceExplorerProviders = resourceExplorerProvidersSelector(state);
  const enableProviders = enabledProvidersSelector(state);
  const enableProvidersArr = Array.from(enableProviders);

  const mutatedInitialFilter = resourceExplorerViewFilters
    ? getResourceExplorerRestructuredFilters(
        resourceExplorerViewFilters,
        resourceExplorerProviders,
        enableProvidersArr,
      )
    : null;

  if (mutatedInitialFilter?.[provider]?.[key]?.operator === filter?.operator) {
    return filter;
  }

  if (mutatedInitialFilter?.[provider]?.[key]?.operator === "not_in") {
    const value = possibleFilters?.values?.reduce((result, item) => {
      if (!filter?.value?.includes(item.value)) {
        result.push(item.value);
      }
      return result;
    }, [] as string[]);

    return {
      ...filter,
      operator: "not_in",
      value,
    };
  }

  const value = possibleFilters?.values?.reduce((result, item) => {
    if (filter?.value?.includes(item.value)) {
      result.push(item.value);
    }
    return result;
  }, [] as string[]);

  return {
    ...filter,
    operator: "in",
    value,
  };
};
